module.exports = __webpack_public_path__ + "img/1480673036.326d1274.jpg";